export const storeUserContext = () => {
    const query = new URLSearchParams(window.location.search);
    const token = query.get("token");

    if (token) {
        fetch(`${process.env.REACT_APP_API_URL}/user?&token=${token}`)
        .then((res) => res.json())
        .then((response) => {
            const userData = response.data;
            localStorage.setItem("userId", `${userData[1]}-${userData[0]}`)
        })
        .catch((error) => {
            console.log(error.message);
        });
    }

};